import { Shield, Users, DollarSign, MessageCircle } from 'lucide-react';

const SafetyFooter = () => {
  const tips = [
    {
      icon: Users,
      title: 'Verify Riders',
      description: 'Only ride with verified students from your campus community.',
    },
    {
      icon: DollarSign,
      title: 'Cash or Venmo',
      description: 'Payment is handled in person. Never share bank details online.',
    },
    {
      icon: MessageCircle,
      title: 'Communicate',
      description: 'Use in-app chat to confirm pickup details and stay connected.',
    },
  ];

  return (
    <footer className="bg-sage-deep/10 border-t border-border mt-8 pb-20">
      <div className="container max-w-lg mx-auto px-4 py-6">
        <div className="flex items-center gap-2 mb-4">
          <Shield className="w-5 h-5 text-accent" />
          <h3 className="font-display font-bold text-foreground">Safety Tips</h3>
        </div>
        <div className="space-y-3">
          {tips.map((tip, index) => {
            const Icon = tip.icon;
            return (
              <div key={index} className="flex items-start gap-3">
                <div className="p-1.5 rounded-lg bg-secondary flex-shrink-0">
                  <Icon className="w-4 h-4 text-accent" />
                </div>
                <div>
                  <h4 className="font-semibold text-sm text-foreground">{tip.title}</h4>
                  <p className="text-xs text-muted-foreground">{tip.description}</p>
                </div>
              </div>
            );
          })}
        </div>
        <p className="mt-4 text-xs text-muted-foreground text-center">
          CollegeRyde is a peer-to-peer community. Always trust your instincts and stay safe! 🌻
        </p>
      </div>
    </footer>
  );
};

export default SafetyFooter;
